// extracted by mini-css-extract-plugin
export default {"errorImgClass":"ImageWithFallback_errorImgClass__3a4mN"};